
export class ManufacturingOrderNotification {

  constructor(
    public hash?: string,
    public notificationDate?: number,
    public comment?: string,
    public userHash?: string,
    public userName?: string,
    public receivers?: string,
    public type?: number,
    public claimedDate?: number,
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-notification.ts